import {FormElement} from "./form-element.js";

/**
 * Represents an input element in a form, extending the behavior of FormElement.
 * This class is designed to encapsulate the creation and management of input-specific elements within a form.
 */
export class InputElement extends FormElement {

    componentTag = "input";

    /**
     * Constructor to initialize the instance with form data, parent element, and a collection.
     *
     * @param {Object} formData - The form data to initialize the instance.
     * @param {HTMLElement} parentElement - The parent element to attach the instance to.
     * @param {Array|Object} collection - The collection associated with the instance.
     * @return {void}
     */
    constructor(formData, parentElement, collection) {
        super(formData, parentElement, collection);
    }


    /**
     * Updates the attributes of the given component.
     *
     * @param {Object} component - The component object to update with attributes.
     * @return {void} This method does not return a value.
     */
    attributes(component) {
        super.attributes(component);

        if (this.noSubmit ?? false) {
           return;
        }
        component.name = this.dataField;
    }

    /**
     * Determines and returns the input type as a string.
     *
     * @return {string} The input type.
     */
    inputType() {
        return "";
    }

    /**
     * Configures a component by setting its type based on the input type defined in the current instance.
     *
     * @return {Object} The configured component with its type set.
     */
    component() {
        const input = super.component();
        input.type = this.inputType();
        return input;
    }
}